import { useContext } from 'react'

import { ConfirmContext, type ConfirmContextValue } from '@/contexts/confirmContext'

export const useConfirm = (): ConfirmContextValue => {
  const context = useContext(ConfirmContext)
  if (!context) {
    throw new Error('useConfirm must be used within a ConfirmProvider')
  }
  return context
}
